// Older phone browsers support AbortController but not AbortSignal.any/timeout.
// Keep cancellation and the deadline active until the response BODY is read.
const request = async (path, options, readBody) => {
  const { timeoutMs = 20000, signal: parent, ...fetchOptions } = options;
  const controller = new AbortController(); let timedOut = false;
  const cancel = () => controller.abort();
  if (parent?.aborted) cancel(); else parent?.addEventListener('abort', cancel, { once: true });
  const timer = setTimeout(() => { timedOut = true; cancel(); }, timeoutMs);
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, { ...fetchOptions, signal: controller.signal });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      const detail = Array.isArray(data.detail) ? data.detail.map(item => item.msg).join(' · ') : data.detail;
      throw new Error(detail || 'The request could not be completed. Please try again.');
    }
    return await readBody(response);
  } catch (error) {
    if (timedOut) throw new DOMException('Loading timed out. Please try again.', 'TimeoutError');
    throw error;
  } finally {
    clearTimeout(timer); parent?.removeEventListener('abort', cancel);
  }
};

export const requestJSON = (path, options = {}) => request(path, options, response => response.json());
export const requestBlob = (path, options = {}) => request(path, options, response => response.blob());